import React from 'react';
import * as Yup from 'yup';
import { FieldItem } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/userFieldNames';
import { GetLoadOptions } from '@lib/components/Select/types';
import UserAccessField from 'routes/Users/UserAccessField/UserAccessField';
import UserAccessFieldReset from 'routes/Users/UserAccessField/UserAccessFieldReset';

type Args = {
  getAssetCategoriesLoadOptions: GetLoadOptions;
  getDocumentationCategoriesLoadOptions: GetLoadOptions;
  getInterventionCategoriesLoadOptions: GetLoadOptions;
  personalInterventionCategoriesIds: string[];
  teamInterventionCategoriesIds: string[];
  personalAssetCategoriesIds: string[];
  teamAssetCategoriesIds: string[];
  personalDocumentationCategoriesIds: string[];
  teamDocumentationCategoriesIds: string[];
};

export default function getUserAccessesFormFields(args: Args): FieldItem[] {
  const {
    getAssetCategoriesLoadOptions,
    getDocumentationCategoriesLoadOptions,
    getInterventionCategoriesLoadOptions,
    personalInterventionCategoriesIds,
    teamInterventionCategoriesIds,
    personalAssetCategoriesIds,
    teamAssetCategoriesIds,
    personalDocumentationCategoriesIds,
    teamDocumentationCategoriesIds,
  } = args;
  return [
    {
      name: FieldNames.Accesses,
      element: UserAccessField,
      componentProps: {
        getAssetCategoriesLoadOptions,
        getDocumentationCategoriesLoadOptions,
        getInterventionCategoriesLoadOptions,
        personalInterventionCategoriesIds,
        teamInterventionCategoriesIds,
        personalAssetCategoriesIds,
        teamAssetCategoriesIds,
        personalDocumentationCategoriesIds,
        teamDocumentationCategoriesIds,
      },
      isUseWatch: true,
      validation: Yup.object(),
    },
    {
      name: FieldNames.AccessesMessage,
      customRender: () => <UserAccessFieldReset name={FieldNames.Accesses} />,
    },
  ];
}
